export function initFeaturedCategoriesSlider() {
  document.addEventListener('DOMContentLoaded', function () {

    const categoriesSlider = new window.splide('.featuredCategories__slider', {
      autoWidth: true,
      gap: 10,
      pagination: false,
      arrows: false,
      mediaQuery: 'min',
      autoplay: true,
      interval: 2000,
      rewind: true,
      breakpoints: {
        768: {
          autoWidth: false,
          perPage: 3,
        },
        992: {
          perPage: 4,
        },
      }
    });

    categoriesSlider.on('overflow', function (isOverflow) {
      categoriesSlider.go(0);

      categoriesSlider.options = {
        drag: isOverflow,
        clones: isOverflow ? undefined : 0,
      };
    });

    categoriesSlider.mount();
  });
}